import React, { FunctionComponent, useContext, useEffect } from 'react'
import { Route, RouteComponentProps, useLocation } from 'react-router-dom'
import { Slide, ToastContainer } from 'react-toastify'
import { Container } from '../../components/layout/'
import { SocketNotificationModal } from '../../components/SocketNotificationModal'
import { Routes } from '../../components/Routes/Routes'
import { useNotifications } from '../Parameters'
import BackendNotificationModal from '../../components/BackendNotificationModal'
import { Theme } from '../ThemeProvider'
import { isMfaPending, StateStore } from '../StoreProvider'
import { datadogRum } from '@datadog/browser-rum'

interface Props {
  authenticated: boolean
}

declare global {
  interface Window {
    ReactNativeWebView: any
    postNativeMessage: any
  }
}

export const App: FunctionComponent<Props> = ({ authenticated }) => {
  const { state } = useContext(StateStore)
 
  const location = useLocation();
  useNotifications()
  useEffect(() => {
    // Derive a clean view name from pathname
    const viewName = location.pathname;
    datadogRum.startView({ name: viewName });
  }, [location.pathname]);
  
  const mfaPending = isMfaPending(state.currentUser)
  const isAuthenticated = authenticated && !!state.currentUser
  return ( 
    <Theme>
      <Container>
        {isAuthenticated && <SocketNotificationModal />}
        {isAuthenticated && <BackendNotificationModal />}
        <ToastContainer autoClose={false} position="top-center" icon={false} transition={Slide} />
        <Route
          render={({ location }: RouteComponentProps) => (
            <Routes authenticated={isAuthenticated} mfaPending={mfaPending} location={location} />
          )}
        />
      </Container>
    </Theme>
  )
}
